import { Box, useTheme } from "@mui/material";
import { useState } from "react";
import { nawyTheme } from "@/styles/nawy-theme/nawy-theme";
import Tasks from "@/modules/meetings/components/tasks/tasks";
import AddNewTask from "@/modules/tasks/components/add-task";
import useScreenSize from "@/modules/common/hooks/device-detection.hook";

export default function TasksModal() {
  const theme = useTheme();
  const screen = useScreenSize();
  const [hasTasks, setHasTasks] = useState(false);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: screen.isMobile ? "auto" : "100%",
      }}
    >
      {/* Content Area */}
      <Box
        sx={{
          flexGrow: 1,
          overflow: "auto",
          minHeight: 0,
        }}
      >
        <Tasks onTasksStatusChange={setHasTasks} />
      </Box>

      {/* Fixed Footer with New Task Button - Only show if there are tasks */}
      {hasTasks && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            backgroundColor: nawyTheme.nawy.colors.semantic.layer.primary,
            padding: nawyTheme.nawy.spacing.md,
            borderTop: `1px solid ${nawyTheme.nawy.colors.semantic.border.secondary}`,
            flexShrink: 0,
          }}
        >
          <AddNewTask
            disableRipple={true}
            addTaskButtonSX={{
              display: "flex",
              alignItems: "center",
              gap: theme.nawy.spacing.xs,
              backgroundColor: "transparent",
              border: "none",
              cursor: "pointer",
              padding: theme.nawy.spacing.xs,
              color: nawyTheme.nawy.colors.semantic.layer.accent,
              ...nawyTheme.nawy.typography.english.variants.body.md.semibold,
              boxShadow: "none",
              "&:hover": {
                opacity: 0.8,
                backgroundColor: "transparent",
                boxShadow: "none",
              },
            }}
          />
        </Box>
      )}
    </Box>
  );
}
